module.exports = __webpack_public_path__ + "img/ads-icon.69042790.svg";